"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("../utils");
var resources_1 = require("../resources");
exports.addColor = function (_a) {
  var value = _a.value;
  return {
    colorClass: utils_1.getColor(value)
  };
};
exports.addScoreName = function (type) {
  return function () {
    return {
      score: {
        id: type,
        name: utils_1.parseType(type)
      }
    };
  };
};
exports.normalizeValues = function (score) {
  return {
    value: Math.round(score.value)
  };
};
exports.mapDescriptions = function (customizations) {
  return function (score) {
    return {
      descriptions: utils_1.getDescriptions(score, customizations)
    };
  };
};
exports.addHint = function (type) {
  return function () {
    return {
      hint: resources_1.scoreHints[type]
    };
  };
};
exports.transformers = function (type, custom) {
  return [exports.addColor, exports.addHint(type), exports.addScoreName(type), exports.normalizeValues, exports.mapDescriptions(custom)];
};
exports.transformScore = function (scores, custom) {
  return function (type) {
    return exports.transformers(type, custom).reduce(function (transformedScore, transform) {
      return __assign({}, transformedScore, transform(transformedScore));
    }, scores[type]);
  };
};